<template>
  <div>
    <!-- Top Announcement Bar -->
    <div class="top-bar">
      <span class="top-text">Professional Physiotherapy Equipment</span>
      <a class="top-link"
        href="https://www.daraz.com.np/shop/rr-multilinks-suppliers/?spm=a2a0e.pdp_revamp.seller.1.23ac477d5RErps&itemId=506406532&channelSource=pdp"
        target="_blank" rel="noopener">
        Visit us on Daraz.np
      </a>
    </div>

    <!-- Main Header with Logo + Menu Toggle -->
    <header class="main-header">
      <div class="logo-section">
        <div class="logo-icon">
          <img :src="require('@/assets/logoimg physio.jpeg')" alt="PhysioNepal Logo" />
        </div>
        <span class="logo-text">PhysioNepal</span>
      </div>

      <!-- Hamburger / Close button (visible only on mobile) -->
      <button class="mobile-menu-toggle" @click="isMenuOpen = !isMenuOpen" aria-label="Toggle menu"
        :aria-expanded="isMenuOpen">
        <span v-if="!isMenuOpen" class="hamburger">☰</span>
        <span v-else class="close">✕</span>
      </button>

      <!-- Navigation Menu -->
      <nav class="main-nav" :class="{ 'open': isMenuOpen }">
        <ul class="nav-list">
          <li><router-link to="/" @click="closeMenu">Home</router-link></li>
          <li><router-link to="/categories" @click="closeMenu">Categories</router-link></li>
          <li><router-link to="/products" @click="closeMenu">Products</router-link></li>
          <li><router-link to="/about" @click="closeMenu">About</router-link></li>
          <li><router-link to="/contact" @click="closeMenu">Contact</router-link></li>
          <li><router-link to="/wishlist" @click="closeMenu">Wishlist</router-link></li>
          <li><router-link to="/cart" @click="closeMenu">Cart</router-link></li>
        </ul>
      </nav>
    </header>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isMenuOpen = ref(false)

const closeMenu = () => {
  isMenuOpen.value = false
}
</script>

<style scoped>
/* Top Announcement Bar */
.top-bar {
  background: #1a1a2e;
  color: white;
  padding: 8px 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
}

.top-link {
  color: #60a5fa;
  text-decoration: none;
  font-weight: 500;
}

.top-link:hover {
  color: #93c5fd;
  text-decoration: underline;
}

/* Main Header */
.main-header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 16px 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1000;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a2e;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #1a1a2e;
  padding: 8px;
}

/* Navigation Menu */
.main-nav {
  display: flex;
  align-items: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;
}

.nav-list li a {
  color: #1a1a2e;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.05rem;
  transition: color 0.2s;
}

.nav-list li a:hover,
.nav-list li a.router-link-active {
  color: #2563eb;
}

/* Mobile Responsive */
@media (max-width: 1024px) {
  .mobile-menu-toggle {
    display: block;
  }

  .main-nav {
    position: fixed;
    top: 0;
    right: -100%;
    width: 280px;
    height: 100vh;
    background: white;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
    transition: right 0.35s ease-in-out;
    z-index: 999;
    padding: 80px 24px 24px;
  }

  .main-nav.open {
    right: 0;
  }

  .nav-list {
    flex-direction: column;
    gap: 1.5rem;
  }

  .nav-list li a {
    font-size: 1.25rem;
    padding: 8px 0;
  }
}

@media (max-width: 480px) {
  .top-bar {
    font-size: 0.85rem;
    padding: 8px 5%;
  }

  .logo-text {
    font-size: 1.3rem;
  }

  .logo-icon img {
    width: 40px;
    height: 40px;
  }
}
</style>